import React from "react";
import { Card, eur, num } from "./primitives";

const KEYS = ["material", "scrap", "cut_setup", "cutting", "piercing", "bend_setup", "bending", "programming", "packaging", "overhead", "margin"];

/** Composizione del totale: righe economiche per componente (PricingEngine), costi d'ordine e aggregati. */
export const CompositionTable = ({ comp }) => {
  if (!comp) return null;
  const labels = {};
  comp.components.forEach((c) => c.rows.forEach((r) => { labels[r.key] = r.label; }));
  const keys = KEYS.filter((k) => labels[k]);
  const t = comp.totals || {}, oc = comp.order_costs || {};
  return (
    <Card title={`Composizione del totale ${eur(t.order_total)} — ${t.label || ""}`} subtitle="Valori €/pezzo dal PricingEngine (stessa esecuzione dei gate); quantità 1 per componente; costi d'ordine una volta per commessa" testId="b03-composition">
      <div className="overflow-x-auto">
        <table className="dense-table w-full min-w-[1100px]">
          <thead><tr><th>Comp.</th><th>mm taglio</th><th>Inneschi</th><th>Tempo laser (min)</th>{keys.map((k) => <th key={k}>{labels[k]}</th>)}<th>Costo industriale €/pz</th><th>Prezzo unitario €</th><th>Qtà</th><th>Riga €</th></tr></thead>
          <tbody>
            {comp.components.map((c) => {
              const rows = Object.fromEntries(c.rows.map((r) => [r.key, r]));
              return (
                <tr key={c.code} data-testid={`b03-comp-row-${c.short}`}>
                  <td className="font-mono font-bold">{c.short}</td><td className="font-mono">{num(c.cut_length_total_mm, 1)}</td><td className="font-mono">{c.pierce_count}</td><td className="font-mono">{num(c.calculated_time_min, 4)}</td>
                  {keys.map((k) => <td key={k} className="font-mono">{num(rows[k]?.unit_eur, 4)}</td>)}
                  <td className="font-mono">{num(c.industrial_unit, 4)}</td><td className="font-mono font-bold" data-testid={`b03-unit-price-${c.short}`}>{num(c.unit_price)}</td><td className="font-mono">{c.quantity}</td><td className="font-mono font-bold">{num(c.line_total)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="grid gap-2 md:grid-cols-2">
        <div className="border border-border bg-ivory p-2 rounded-sm">
          <div className="font-bold mb-1">Costi d'ordine (una volta per commessa)</div>
          {(oc.rows || []).map((r) => <div key={r.key} className="flex justify-between border-b border-border/40 py-0.5"><span>{r.label} <span className="text-muted-foreground">({r.basis})</span></span><span className="font-mono">{eur(r.eur)}</span></div>)}
          <div className="flex justify-between font-bold pt-1"><span>Prezzo costi d'ordine</span><span className="font-mono" data-testid="b03-order-costs-price">{eur(oc.price)}</span></div>
        </div>
        <div className="border border-border bg-ivory p-2 rounded-sm">
          <div className="font-bold mb-1">Formazione del totale</div>
          <div className="flex justify-between border-b border-border/40 py-0.5"><span>Σ righe componenti</span><span className="font-mono" data-testid="b03-sum-lines">{eur(comp.sum_line_totals)}</span></div>
          <div className="flex justify-between border-b border-border/40 py-0.5"><span>+ costi d'ordine</span><span className="font-mono">{eur(oc.price)}</span></div>
          <div className="flex justify-between font-black text-sm pt-1"><span>{t.label}</span><span className="font-mono" data-testid="b03-order-total">{eur(t.order_total)}</span></div>
          <div className="text-[10px] text-muted-foreground mt-1">Aggregati: materiale {eur(t.material)} · sfrido {eur(t.scrap)} · lavorazioni {eur(t.processing)} · attrezzaggi/programmazione {eur(t.setups)} · costi generali {eur(t.overhead)} · margine {eur(t.margin)} · costo industriale {eur(t.industrial)} · peso {t.weight_kg} kg · {t.tax?.label} · parziale: {String(t.partial)}</div>
        </div>
      </div>
    </Card>
  );
};
